import './TotalReceivable.scss';
import { TableUtility } from '@utility/dynamic-table';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import PropTypes from 'prop-types';
import { useCollectionReport } from '../../../Hooks/useCollectionReport';
import { MIS_COLLECTION_REPORT } from '../../../Constants/strings';

const VerticalReceivableTable = ({ baseURL, createDownloadAllHandler }) => {
  const { empDetails } = useCollectionReport();
  const configuration = {
    generalSettings: {
      enableApiFiltering: true,
      showPagination: false,
      baseURL,
      userInfo: empDetails,
      apiEndpoints: {
        getFilteredData: { endpoint: '', enabled: true },
        download: { endpoint: 'download', enabled: true },
      },
      handler: {
        setDownloadDataHandler: (handler) => {
          createDownloadAllHandler(MIS_COLLECTION_REPORT.TOTAL_RECEIVABLE, handler);
        },
      },
      headers: {
        'Content-Type': 'application/json',
        token: empDetails.access_token,
      },
    },
    showToolBar: false,
    tableSettings: {
      size: 'small',
      loaderSkeleton: {
        rows: 6,
        bodyCells: 1,
        columns: 3,
      },
      tableScrollHeight: '100%',
      maxFrozenColumns: {
        desktop: 1,
        tablet: 1,
        mobile: 1,
      },
    },
  };
  return (
    <div className="sub-table-one">
      <TableUtility configuration={configuration} />
    </div>
  );
};

VerticalReceivableTable.propTypes = {
  baseURL: PropTypes.string.isRequired,
  createDownloadAllHandler: PropTypes.func.isRequired,
};

export default VerticalReceivableTable;
